import { CartGetItem } from 'src/types';
import TagManager from 'react-gtm-module';

type Args = {
  cartId: string;
  cartItems: CartGetItem[];
  // loggerUrl: string;
  // cartValue: number;
  // cartCCY: string;
  // page: 'get' | 'embed';
};

export const sendCartToMscdirect = ({
  cartId,
  cartItems,
  // cartValue,
  // cartCCY = 'USD',
  // page = 'get',
}: Args) => {
  let cartUrl = 'https://www.mscdirect.com/cart/quickorderadd';

  const params = [];
  for (let i = 0; i < cartItems.length; i++) {
    const index = i + 1;
    params.push(`productId_${index}=${cartItems[i].asin}`);
    params.push(`quantity_${index}=${cartItems[i].quantity}`);
  }

  cartUrl = `${cartUrl}?${params.join('&')}`;

  TagManager.dataLayer({
    dataLayer: {
      event: 'Send to Vendor',
      eventCategory: 'engagement',
      eventLabel: 'Get Page',
      eventValue: {
        cartId,
        cartVendor: 'MSC Industrial',
      },
    },
  });

  return (cartUrl = `${encodeURIComponent(cartUrl)}`);
};
